import { z } from 'zod';

/**
 * Mirrors `loginSchema` in the backend's auth.validation.ts.
 *
 * Validating here too means the user sees the mistake instantly instead of
 * after a round trip. The server still validates — client rules are for
 * convenience, never for security.
 */
export const loginSchema = z.object({
  identifier: z
    .string()
    .trim()
    .min(1, 'Please enter your email or phone number')
    .max(150, 'That is too long'),
  password: z.string().min(1, 'Please enter your password').max(128, 'That is too long'),
  rememberMe: z.boolean().default(false),
});

export type LoginFormValues = z.infer<typeof loginSchema>;
